<app-boxes-page-component></app-boxes-page-component>
